// Central de Indicações (pedido 2026-09-27, só no app) — backend real em
// gpsdrive-backend-release-fase1-2/src/referrals/. O cliente só lê as
// próprias indicações; as etapas avançam sozinhas no servidor.
import { gpsDriveGet, gpsDrivePost } from "@/lib/api/gpsdrive-client";

export type ReferralStatus = "cadastrado" | "negociacao" | "cliente";

export interface ReferralAchievement {
  key: "first" | "five" | "ten" | "five_clients";
  title: string;
  description: string;
  target: number;
  current: number;
  achieved: boolean;
  achievedAt: string | null;
  unlockedByThis?: boolean;
}

export interface ReferralSummary {
  code: string;
  stats: { total: number; cadastrados: number; negociacao: number; clientes: number };
  achievements: ReferralAchievement[];
  nextAchievement: ReferralAchievement | null;
}

export interface ReferralListItem {
  id: string;
  name: string;
  status: ReferralStatus;
  registeredAt: string;
  updatedAt: string;
}

export interface ReferralDetail {
  id: string;
  name: string;
  status: ReferralStatus;
  registeredAt: string;
  timeline: { key: "link" | "cadastro" | "negociacao" | "cliente"; title: string; at: string | null }[];
  achievements: ReferralAchievement[];
}

export interface PublicReferralInfo {
  companyName: string;
  referrerFirstName: string;
}

const enc = encodeURIComponent;

export const gpsDriveReferralsService = {
  summary: () => gpsDriveGet<ReferralSummary>("/api/v1/referrals/me"),
  list: (status?: ReferralStatus) =>
    gpsDriveGet<ReferralListItem[]>(`/api/v1/referrals/me/list${status ? `?status=${status}` : ""}`),
  detail: (id: string) => gpsDriveGet<ReferralDetail>(`/api/v1/referrals/me/${enc(id)}`),

  publicInfo: (code: string) => gpsDriveGet<PublicReferralInfo>(`/api/v1/public/referrals/${enc(code)}`),
  registerVisit: (code: string) =>
    gpsDrivePost<{ visitToken: string }>(`/api/v1/public/referrals/${enc(code)}/visit`),
  register: (code: string, input: { name: string; phone: string; visitToken?: string }) =>
    gpsDrivePost<{ ok: true }>(`/api/v1/public/referrals/${enc(code)}`, input),
};

// Mesmo racional de locationShareUrl: no APK a WebView já roda na origin
// real; o fallback cobre file:// / capacitor://.
export function referralUrl(code: string): string {
  const origin =
    typeof window !== "undefined" && /^https?:/.test(window.location.origin)
      ? window.location.origin
      : "https://gpsdrive.com.br";
  return `${origin}/indicacao/${code}`;
}
